import React from 'react';
import PropTypes from 'prop-types';
import { Router, Switch, Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { flyerBasePathWithoutPage } from 'app/routes';
import GenericRoute from 'splash/routes/generic.route';
import FlyerRoute from 'splash/routes/flyer.route';

const history = createBrowserHistory();

const SplashRoutes = ({ hideThumbnail, logoUrl }) => (
  <Router history={history}>
    <Switch>
      <Route
        path={flyerBasePathWithoutPage}
        render={() => <FlyerRoute hideThumbnail={hideThumbnail} logoUrl={logoUrl} />}
      />
      <Route component={GenericRoute} />
    </Switch>
  </Router>
);

SplashRoutes.propTypes = {
  hideThumbnail: PropTypes.bool,
  logoUrl: PropTypes.string,
};

SplashRoutes.defaultProps = {
  hideThumbnail: false,
  logoUrl: null,
};

export default React.memo(SplashRoutes);
